import Pauta from '../components/Pauta';

export default function PautaProspeccao() {
  return <Pauta statusPauta="Em Prospecção" colunas={[]} corPauta="#7b1fa2" permitirNova={true} />;
}